Wee.fn.make('video', {
    init: function() {
        $.events.on({
            'ref:videoWrap': {
                click: function() {
                    Wee.$removeClass('ref:videoWrap', '-stopped');
                    Wee.$prop('ref:videoPlayer', 'controls', true);
                }
            }
        });
    }
});

Wee.video.init();
